import { CurrencyOptions } from "../constants";

export const loadCallback = <T extends (...P: any[]) => any>(cb?: T, ...data: Parameters<T>): ReturnType<T> => {
  return cb && cb(...data);
};

/**
 * Hiện giá trị theo định dạng tiền tệ của US
 * @param number kiểu dữ liệu number
 */
export function currencyFormat(number: number) {
  // output: 5,000,000
  return new Intl.NumberFormat("en-US").format(number);

  // output: 5.0000.000
  // return new Intl.NumberFormat("en-DE").format(number);
}

export function getFirstChar(str: string): string {
  return str.charAt(0);
}

export function convertTagString(
  tagStr: string | undefined | null,
  config?: {
    seperator?: string;
  }
): string[] {
  if (!tagStr) return [];

  const seperator = config?.seperator || "|";
  let tags: string[] = tagStr.split(seperator);

  tags = tags.filter((tag) => {
    return !!tag.trim();
  });

  return tags;
}

export function currencyUnitFormat(number: number, unit: string) {
  const foundCur = CurrencyOptions.find((e) => e.id === unit);
  return foundCur
    ? new Intl.NumberFormat(foundCur?.locale || "en-US", {
        style: "currency",
        currency: unit,
        minimumFractionDigits: number % 1 === 0 ? 0 : 2,
      }).format(number)
    : 0;
}
